import React from 'react';

import Container from './Container';
import Date from './Date';
import IpAddress from "./IpAddress";
import Alias from "./Alias";
import Mode from "./Mode";
import TotalIps from "./TotalIps";
import TotalDiffIps from "./TotalDiffIps";

export default ({ log }) => (
  <Container>
    <Date>{log.latest_created_at}</Date>
    <Alias>{log.alias}</Alias>
    <Mode>{log.mode}</Mode>
    <IpAddress>{log.latest_ip_address}</IpAddress>
    <TotalIps>{log.total_ips}</TotalIps>
    <TotalDiffIps>{log.total_diff_ips}</TotalDiffIps>
  </Container>
);
